jQuery(document).ready(function ($) {

    $(".confirmation").click(function(e) {
      if(!confirm("Êtes-vous sur de vouloir effectuer cette action ?")){
          e.preventDefault();
          return false;
      }
  });

    /* ==========================================================================
    == OBFUSCATION DE LIEN ==
    ========================================================================== */

    $(".js_fake_href").on("click", function() {
      if ($(this).data("href")) {
        if ($(this).data("target") == "_blank") {
            window.open(atob($(this).data("href")));
        } else {
            window.location.href = atob($(this).data("href"));
        }
      }
    });

    /* ==========================================================================
    == SINGLE : PARTAGE RESEAU SOCIAUX ==
    ========================================================================== */

    $(".button-share").on("click", function() {
      $('#button-share-group').toggle();
    });
    $("#button-share-group").hide();

   /* ==========================================================================
    == SINGLE : PARTAGE RESEAU SOCIAUX ==
    ========================================================================== */

    $("#js-comments-btn").on("click", function() {
      $('#js-comments').toggle();
    });
    $("#js-comments").hide();



    /* ==========================================================================
    == SCROLL  ==
    ========================================================================== */

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 10) {
          $("body").addClass("is_scroll");
      } else {
        $("body").removeClass("is_scroll");
      }
    });
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
        $("body").addClass("is_scroll");
    } else {
      $("body").removeClass("is_scroll");
    }

    /* ==========================================================================
    == HEADER TOGGLE SEARCH ==
    ========================================================================== */

    $('.js-search').on('click', function(){
        $('.header-form-search').toggleClass('is-hidden');
        $('i', '.js-menu').removeClass('icon-close').addClass('icon-barsearch');
        $('.menu').removeClass('is-open').removeClass('animating');
        $('body').removeClass('has-menu-open');
    });


    /* ==========================================================================
    == NAV MOBILE ==
    ========================================================================== */

    $('.js-menu').click(function(){

        $('.menu').addClass('animating');

        if ($('i', this).hasClass('icon-barsearch')) {
            $('i', this).removeClass('icon-barsearch').addClass('icon-close');
            $('.menu').addClass('is-open');
            $('body').addClass('has-menu-open');
        } else {
            $('i', this).removeClass('icon-close').addClass('icon-barsearch');
            $('.menu').removeClass('is-open');
            $('body').removeClass('has-menu-open');
        }

        setTimeout(function() {
            $('.menu').removeClass('animating');
        }, 400);

        return false;

    });

    $('#menu-overlay').click(function() {
        $('.menu').addClass('animating');

        $('.icon-close').removeClass('icon-close').addClass('icon-barsearch');
        $('.menu').removeClass('is-open');
        $('body').removeClass('has-menu-open');

        setTimeout(function() {
            $('.menu').removeClass('animating');
        }, 400);
    });

    /*$('.menu-item-has-children > a').click(function(){
        $(this).next('.sub-menu').toggleClass('is-open');
        return false;
    });*/



    /* ==========================================================================
    == BLOC TEL CTA ==
    ========================================================================== */

    $(".js-button-tel").click(function(){
        $(".js-numero-tel").removeAttr("hidden");
        $(".js-cta-tel").attr("hidden","");
        $(this).removeClass("anndetail__pointer");
    });



    /* ==========================================================================
    == BLOC AUTEUR (SINGLE) ==
    ========================================================================== */

    $('.author-content-nav :first-child').addClass('is-active');
    $('.author-content-tabs :first-child').addClass('is-open');

    $('.author-toggle').click(function(){
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('icon-chevron-up is-active').addClass('icon-chevron-down');
            $('.author-content').removeClass('is-open');
        } else {
            $(this).removeClass('icon-chevron-down').addClass('icon-chevron-up is-active');
            $('.author-content').addClass('is-open');
        }
        return false;
    });

    $('.author-content-nav a').click(function(){
        var tab = $(this).attr('data-tab');
        $('.author-content-nav a').removeClass('is-active');
        $('.author-content-tab').removeClass('is-open');
        $(this).addClass('is-active');
        $("#"+tab).addClass('is-open');
    })

    /* ==========================================================================
    == SLICK  ==
    ========================================================================== */

        /* == AUTEURS & EXPERTS SIDEBAR==
        ============================ */

        // $('.auth-list').slick({
        //     dots: false,
        //     arrows: false,
        //     autoplay: true,
        //     autoplaySpeed: 5000,
        //     fade: true,
        //     speed: 800,
        //     cssEase: 'linear'
        // });


        /* == SECTION SLIDER ==
        ============================ */

        /*
        $(".section-full-slider").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
        */


        $(".js-slider-related").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
                },
                {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
                }
            ]
        });

       $(".js-slider-bandeau").slick({
        dots: false,
        arrows: false,
        autoplay: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 550,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            }
          ]
      });
       $(".js-slider-chez-moi").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
                },
                {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
                }
            ]
        });
        $(".js-slider-video").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
        $(".js-slider-tribune").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
        $(".js-slider-podcasts").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
        $(".js-slider-visite-privee").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 800,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });

        $(".section-full-control-left").click(function(){
            var slider = $(this).closest(".section-full").find(".section-full-slider");
            slider.slick("slickPrev");
        });
        $(".section-full-control-right").click(function(){
            var slider = $(this).closest(".section-full").find(".section-full-slider");
            slider.slick("slickNext");
        });


    /* ==========================================================================
    == SHARE BY SMS IOS/ANDROID ==
    ========================================================================== */

    function getMobileOperatingSystem() {
      // Credit: Ryan kulp @ https://www.quora.com/Has-anyone-successfully-preset-body-copy-within-a-tap-to-SMS-link/answer/Ryan-Kulp
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    	if ( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) ) {
        document.getElementsByTagName('body')[0].className+=' ios';
        return 'iOS';
      }

    	else if ( userAgent.match( /Android/i ) ) {
            document.getElementsByTagName('body')[0].className+=' android';
        return 'Android';
      }

    	else { return 'non-mobile or unknown'; }
    }

    var deviceType = getMobileOperatingSystem();
    var linkSms = "";
    if (deviceType == "Android") {
        linkSms = "sms:?body=" + window.location.href;
    } else if (deviceType == "iOS") {
        linkSms = "sms:&body=" + window.location.href;
    }

    $("#share-sms").attr("href", linkSms);





    /* ==========================================================================
    == LOG ANNUAIRE ==
    ========================================================================== */

    $(".js_log").click(function(e){
        console.log($(this));
        var field = $(this).data("field");
        var uid = $(this).closest(".js-annuaire").data("uid");
        $.post(
            ajaxurl,
            {
                'action': 'ajaxlog',
                'field': field,
                'uid': uid
            },
            function(response){
                console.log(response);
            }
        );
    });


    $(".js_confirmation").click(function(e) {
		if(!confirm("Êtes-vous sur de vouloir effectuer cette action ?")){
			e.preventDefault();
			return false;
		}
	});


    $("#accept-wrap").hide();
    $(".annform__submit").click(function(e){
        $("#accept").removeAttr("required");
    });

    /* ==========================================================================
    == SHOW MORE RECOMMANDATIONS POSTS
    ========================================================================== */
    $("#readmore-btn").click(function() {
        $(".secondgrid").removeClass('is-hidden');
        $("#readmore-btn").hide();
    });

    $('.header__expandbtn').click(function() {
        var siblings = $(this).siblings('.sub-menu');

        if (siblings.hasClass('is-open')) {
            siblings.removeClass('is-open');
            $(this).text("+");
        } else {
            siblings.addClass('is-open');
            $(this).text("-");
        }
    });

    $(".js-summary").click(function() {
      $(this).closest(".summary").find(".summary-body").toggle();
      $(this).closest(".summary").find(".icon").toggleClass("active");
  });
});
